export const selectProductGroups = state => {
  const groups = state.PlatformsReducer.groups;
  const items = state.PlatformsReducer.items;
  return groups.reduce((ac, g) => {
    g.items = items.filter(i => i.productGroupId === g.productGroupId);
    if (ac[g.categoryId]) {
      ac[g.categoryId].push(g);
    } else {
      ac[g.categoryId] = [g];
    }
    return ac;
  }, {});
};

export const selectProductGroupsName = state => {
  return state.PlatformsReducer.groupsCatalog.map(g => {
    g.name = String(g.productGroup).trim();
    return g;
  });
};
export const selectMenuItemsName = state => {
  return state.PlatformsReducer.itemsCatalog.map(i => {
    return i;
  });
};

export const selectMenuItemsComplete = state => {
  const categories = state.PlatformsReducer.categories;
  const groups = state.PlatformsReducer.groups;
  const items = state.PlatformsReducer.items;
  return categories.map(p => {
    p.groups = groups
      .filter(g => g.categoryId === p.categoryId)
      .map(g => {
        g.items = items.filter(i => i.productGroupId == g.productGroupId);
        return g;
      });
    return p;
  });
};
export const selectMenuItemsCompleteObjects = state => {
  const categories = state.PlatformsReducer.categories;
  const groups = state.PlatformsReducer.groups;
  const items = state.PlatformsReducer.items;
  return categories.reduce((ac, p) => {
    ac[p.platformID] = { ...p };
    ac[p.platformID].groups = groups
      .filter(g => g.categoryId === p.platformID)
      .reduce((ag, g) => {
        ag[g.productGroupId] = { ...g };
        ag[g.productGroupId].items = items.filter(
          i => i.productGroupId == g.productGroupId,
        );
        return ag;
      }, {});
    return ac;
  }, {});
};
